import React, { useState, useEffect } from "react";
import { getLinks } from "../api/linkApi";
import { Link } from "react-router-dom";
import Footer from "./Footer";

function Home() {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState();

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const links = await getLinks("Latest News");
        console.log("🟢 Fetched News for Home Page:", links);

        // const sortedLinks = links.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        const sortedLinks = links.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        // setNewsItems(Array.isArray(links) ? links : []);
        // setNewsItems(sortedLinks.slice(-3));
        setNewsItems(sortedLinks.slice(0, 3));
      } catch (error) {
        console.error("❌ Error fetching news:", error);
        setNewsItems([]);
      }
    };
    fetchNews();
  }, []);



  return (
    <div className="w-full font-sans">
      {/* Hero Section */}
      <div className="relative w-full">
        <div className="relative w-full h-full">
          <video
            src="/New_Opening_Clip_HD.mp4"
            autoPlay
            loop
            muted
            playsInline
            webkit-playsinline="true"
            className="w-full h-full object-cover"
          />
          {/* <div className="absolute bottom-4 left-0 right-0 text-white text-center px-6 sm:px-12">
            <div className="bg-black bg-opacity-50 p-1 rounded-xl inline-block max-w-max">
              <h1 className="text-xl md:text-5xl font-bold">Welcome to the Owen Lab</h1>
              <p className="text-sm md:text-xl mt-4 max-w-max mx-auto">
                Advancing cognitive neuroscience through cutting-edge research and innovation.
              </p>
            </div>
          </div> */}
          {/* Overlay wrapper */}
          <div className="absolute inset-x-0 bottom-0 sm:bottom-4 flex justify-center px-4 pb-1 sm:pb-0">
            {/* box: semi-opaque on mobile, transparent on sm+ */}
            <div className="text-center rounded-lg px-3 py-1 max-w-[90%]
                  bg-black/30 sm:bg-black/60
                  backdrop-blur-sm">
              <h1 className="text-white drop-shadow-lg
                   text-base sm:text-xl md:text-2xl lg:text-4xl
                   font-bold leading-snug">
                Welcome to the Owen Lab
              </h1>
              <p className="mt-1 text-white drop-shadow-md
                  text-xs sm:text-sm md:text-md lg:text-lg
                  leading-tight">
                Advancing cognitive neuroscience through cutting-edge research and innovation.
              </p>
            </div>
          </div>


        </div>
      </div>

      {/* Research Section */}
      {/* <div className="max-w-6xl mx-auto my-12 px-6 grid grid-cols-1 md:grid-cols-2 items-center gap-10">
        <div className="p-6 text-gray-800">
          <h2 className="text-4xl font-bold text-primary mb-6">Our Research</h2>
          <p className="text-lg leading-relaxed mb-4">
          Dr. Adrian M. Owen, OBE, FRS, FRSC, PhD. is a Professor at the Western Institute for Neuroscience (WIN), at the University of Western Ontario, Canada, and the former Canada Excellence Research Chair (CERC) in Cognitive Neuroscience and Imaging. He is also a Fellow and a former Director of the CIFAR, Brain, Mind, and Consciousness program and co-founder and Chief Scientific Officer of Creyos Inc.
          </p>
          <p className="text-lg leading-relaxed mb-4">
          The research in his lab combines cutting-edge neuroimaging techniques with cognitive studies in both brain-injured patients and healthy participants. By bridging the gap between cognitive neuroscience and clinical application, his lab strives to develop innovative tools for improving brain function and enhancing patient care.
          </p>
        </div>
        <img
          src="/Adrian1.jpg"
          alt="Research at OwenLab"
          className="w-full h-auto rounded-lg shadow-lg"
        />
      </div> */}
      {/* Research Section */}
      <div className="max-w-6xl mx-auto my-12 px-6 grid grid-cols-1 md:grid-cols-2 items-center gap-10">
        <div className="p-6 text-gray-800">
          <h2 className="text-4xl font-bold text-primary mb-6">Our Research</h2>
          <p className="text-lg leading-relaxed mb-4">
            Dr. Adrian M. Owen,{" "}
            <a
              href="https://en.wikipedia.org/wiki/Order_of_the_British_Empire"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              OBE
            </a>
            ,{" "}
            <a
              href="https://en.wikipedia.org/wiki/Fellow_of_the_Royal_Society"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              FRS
            </a>
            ,{" "}
            <a
              href="https://en.wikipedia.org/wiki/Fellow_of_the_Royal_Society_of_Canada"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              FRSC
            </a>
            ,{" "}
            <a
              href="https://cahs-acss.ca/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              FCAHS
            </a>
            , PhD, is a Professor at the{" "}
            <a
              href="https://win.uwo.ca/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              Western Institute for Neuroscience (WIN)
            </a>
            , at the{" "}
            <a
              href="https://uwo.ca/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              University of Western Ontario, Canada
            </a>
            , and the former{" "}
            <a
              href="https://www.cerc.gc.ca/home-accueil-eng.aspx"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              Canada Excellence Research Chair (CERC)
            </a>
            {" "}in Cognitive Neuroscience and Imaging. He is also a Fellow and a former Director of the{" "}
            <a
              href="https://cifar.ca/research-programs/brain-mind-consciousness/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              CIFAR
            </a>
            , Brain, Mind, and Consciousness program and co-founder and Chief Scientific Officer of{" "}
            <a
              href="https://creyos.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              Creyos Inc.
            </a>
          </p>
          <p className="text-lg leading-relaxed mb-4">
            The research in his lab combines cutting-edge neuroimaging techniques with cognitive studies in both brain-injured patients and healthy participants. By bridging the gap between cognitive neuroscience and clinical application, his lab strives to develop innovative tools for improving brain function and enhancing patient care.
          </p>
        </div>
        <img
          src="/Adrian1.jpg"
          alt="Research at OwenLab"
          className="w-full h-auto rounded-lg shadow-2xl shadow-black/100"
        />
      </div>


      {/* Headlines Section */}
      <div className="max-w-6xl mx-auto my-16 px-6">
        <div className="flex justify-between items-center mb-4 border-b border-primary pb-2">
          <h2 className="text-4xl font-bold text-primary">Latest News</h2>
          <div className="flex space-x-4">
            <Link
              to="/MediaEnquiries"
              className="bg-accent text-white font-semibold py-2 px-4 rounded-md hover:bg-opacity-80 transition duration-300"
            >
              Media Enquiries
            </Link>
          </div>
        </div>
        {loading ? (
          <p className="text-center text-gray-600">Loading latest news...</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {newsItems.map((news) => (
              <a
                key={news._id}
                href={news.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-2xl transition duration-300"
              >
                <div className="relative">
                  {/* <img src={news.imageUrl} alt={news.title} className="w-full h-52 object-cover" /> */}
                  <img
                    src={news.imageUrl || "/default-placeholder.png"}
                    alt={news.title}
                    className="w-full h-52 object-cover"
                    onError={(e) => e.target.src = "/default-placeholder.png"} // ✅ Fallback for broken images
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent opacity-75"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-900 hover:text-primary transition duration-300">
                    {news.title}
                  </h3>
                </div>
              </a>
            ))}
          </div>
        )}
      </div>

      {/* New Section: Half Image, Half Text with Buttons */}
      {/* <div className="max-w-6xl mx-auto my-16 px-6 grid grid-cols-1 md:grid-cols-2 items-center">
        <img
          src="/Discover-owen-lab-1.jpg"
          alt="OwenLab Research Overview"
          className="w-full h-full object-cover rounded-lg shadow-lg"
        />
        <div className="p-10 text-gray-800">
          <h2 className="text-4xl font-bold text-westernPurple mb-4">Discover The Owen Lab</h2>
          <p className="text-lg leading-relaxed mb-6">
            Uncover groundbreaking research in cognitive neuroscience and imaging. Our studies aim to advance the understanding of brain function and neurological disorders.
          </p>
          <div className="flex space-x-4">
            <Link
              to="/Research"
              className="bg-westernPurple text-white text-lg font-semibold py-3 px-6 rounded-lg shadow-md hover:bg-opacity-90 transition duration-300"
            >
              Explore Research
            </Link>
            <Link
              to="/Publications"
              className="border border-westernPurple text-westernPurple text-lg font-semibold py-3 px-6 rounded-lg shadow-md hover:bg-westernPurple hover:text-white transition duration-300"
            >
              View Publications
            </Link>
          </div>
        </div>
      </div> */}

      {/* Footer Section */}
      <Footer />
      {/* <Footer isFullFooter={true} /> */}
    </div>
  );
}

export default Home;









